<div class="center-align">
    <div class="display-45">

            <div   class="header-blue">
                <div >
                    <img class="mr-4" style="width: 35px;" src="../../../assets/Logos/attention.png" />
                    {{'InvalidLabel_001' | translate}}
            </div>
                <div class="language-change" id="languageDropdown" (click)="changeLanguage()">
                    {{ defaultLanguage === 'NL'? 'FR': 'NL' }}
                  </div>
            </div>
            <div style="z-index: 10;">
                
            <div class="card-body border-external">
                <table WIDTH="100%"  >  
                    <tr >
                        <td width="75%">
                        <div class="labelforInvalid">
                             <span>
                                  {{'InvalidMessage_001' | translate}}
                                  <!-- Désolé, ce lien n'est plus valable… -->

                                </span>
                            </div> 
                        <div class="InvalidMessage">
                            <span>
                                {{'InvalidMessage_002'| translate}}
                                <!-- Vous pouvez réitérer votre demande ci-dessous   -->

                            </span>
                        </div>  
                    </td>
                        <td width="25%">
                             <img src="../../../assets/Logos/sandclock.png" width="100" height="100"/> 
                        </td>
                    </tr>
              </table>              
            </div>
            <div   class="footer-class border-external">
                    <!-- <a class="clslink"  (click)="Forgotpasswordfn()">{{ 'ForgotPasswordLink_001' | translate }}</a>  -->
                    <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32"
                    viewBox="0 0 172 172" style="height: 50px; fill:#000000;">
                     
                </svg>
                   <b> <a class="clslink" style="color: steelblue;"  (click)="Forgotpassword()">{{ 'ForgotPasswordLink_001' | translate }}</a> </b>
                
            </div>
         
        </div>
</div>  
</div>

 
   

